import { KnowledgeBaseFolderLite } from 'api/knowledge-base/types';
import styled from 'styled-components';
import { KnowledgeBaseFolder } from './folder';

const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 350px));
  gap: var(--spacing-05);
`;

type Props = {
  folders: KnowledgeBaseFolderLite[];
};
export const KnowledgeBaseFolderList = ({ folders }: Props) => {
  return (
    <ListWrapper>
      {folders.map((folder) => (
        <KnowledgeBaseFolder key={folder.folderId} folder={folder} />
      ))}
    </ListWrapper>
  );
};
